module.exports = __webpack_public_path__ + "img/大图.c343aa91.jpg";